// Donation amount rules, shared by the donate form and the server that
// initialises the transaction. The server is the one that enforces them.

// The floor blocks the tiny charges card testers use to check a stolen card;
// the ceiling caps obviously abusive amounts. Larger gifts go via EFT.
export const DONATION_MIN_RANDS = 20;
export const DONATION_MAX_RANDS = 50_000;

export const DONATION_FREQUENCIES = ["recurring", "once-off"] as const;
export type DonationFrequency = (typeof DONATION_FREQUENCIES)[number];

/** A whole-rand amount within the donation limits. */
export function isValidDonationAmount(amountRands: number): boolean {
  return (
    Number.isInteger(amountRands) &&
    amountRands >= DONATION_MIN_RANDS &&
    amountRands <= DONATION_MAX_RANDS
  );
}
